import React,{useEffect} from 'react';
import { Col, Container, Nav, NavLink, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import "../Banner/Banner.css";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Banner = ({banner}) => {
    useEffect(() => {
        AOS.init();
      }, [])
    return (
        <>
            <section className='banner-wrp'>
                <div className='banner-top' style={banner.bgimg}>
                    <Container>
                        <div className='banner-main'>
                            <div className='main-title'>
                                <h1>{banner.title}</h1>
                            </div>
                            <div className='banner-middle'>
                                <Row className='align-items-end'>
                                    <Col md={6} lg={6} xl={6} xxl={6}>
                                        <div className='banner-left'>
                                            <Nav.Link href="/home#star-for-free" className='btn btn-black'>{banner.btn}</Nav.Link>
                                            <div className='common-detail font-500'>
                                                <p>{banner.leftdetail}</p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={6} lg={6} xl={6} xxl={6}>
                                        <div className='banner-right'>
                                            <div className='common-detail'>
                                                <p>{banner.rightdetail}</p>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Container>
                </div>
                <div className='banner-bottom'>
                    <Container>
                        <div className='banner-section'>
                            <div className='banner-img'>
                                <img src={banner.bannerimg} alt={banner.alt} className='img-fluid d-none d-md-block' />
                                <img src={banner.bannerimgmobile} alt={banner.alt} className='img-fluid d-block d-md-none' />
                            </div>
                            <div className='banner-block'>
                                {banner.contents && banner.contents.map((content, index) => (
                                    <div data-aos="fade-up" data-aos-duration="700" className={`banner-content banner-content-${index}`} key={index} id={`banner-content-${index}`}>
                                        <div className='sub-title'>
                                            <h3>{content.subTitle}</h3>
                                        </div>
                                        <div className='detail'>
                                            <p>{content.detail}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Container>
                </div>
            </section>  
        </>
    )
}

export default Banner;